const FI_ImagesData = [
    {
        src: "/Assets/FI_Images/01-1-1-1.webp",
        keywords: "Roller Blinds",
    },
    {
        src: "/Assets/FI_Images/02-1-1.webp",
        keywords: "Curtain with Blinds",
    },
    {
        src: "/Assets/FI_Images/03-2-1-1.webp",
        keywords: "Roman Blinds",
    },
    {
        src: "/Assets/FI_Images/04-1-1-1.webp",
        keywords: "Curtain with Blinds",
    },
    {
        src: "/Assets/FI_Images/05-4-1.webp",
        keywords: "Colby Blinds",
    },
    {
        src: "/Assets/FI_Images/06-2-1.webp",
        keywords: "Luzon Blinds",
    },
    {
        src: "/Assets/FI_Images/07-1-1-1.webp",
        keywords: "",
    },
    {
        src: "/Assets/FI_Images/08-3-1.webp",
        keywords: "Grayson Blinds",
    },
    {
        src: "/Assets/FI_Images/09-1-1-1.webp",
        keywords: "Sierra Blinds",
    },
    {
        src: "/Assets/FI_Images/10-1-1-1.webp",
        keywords: "Wooden Venetian Blinds",
    },
    {
        src: "/Assets/FI_Images/11-1-1.webp",
        keywords: "Panel Blinds",
    },
    {
        src: "/Assets/FI_Images/12-2.webp",
        keywords: "Patricia Blinds",
    },
    {
        src: "/Assets/FI_Images/13-1.webp",
        keywords: "Meliso Blinds",
    },
    {
        src: "/Assets/FI_Images/14-1-1.webp",
        keywords: "Eton Blinds",
    },
    {
        src: "/Assets/FI_Images/16-1-1.webp",
        keywords: "Dorren Blinds",
    },
    {
        src: "/Assets/FI_Images/15-1-1.webp",
        keywords: "Aric Blinds",
    },
    {
        src: "/Assets/FI_Images/18-1-1.webp",
        keywords: "Vertical Blinds",
    },
    {
        src: "/Assets/FI_Images/19-1-1.webp",
        keywords: "Colby Blinds, Skylight Colby Blinds",
    },
    {
        src: "/Assets/FI_Images/20-1.webp",
        keywords: "Curtain with Blinds",
    },
    {
        src: "/Assets/FI_Images/roller_inspiration-2-1.webp",
        keywords: "Roller Blinds",
    },
    {
        src: "/Assets/FI_Images/roller_inspiration-1-1-1.webp",
        keywords: "Roller Blinds",
    },
    {
        src: "/Assets/FI_Images/roller_inspiration-2-1-1-1.webp",
        keywords: "Roller Blinds",
    },
    {
        src: "/Assets/FI_Images/151-1.webp",
        keywords: "Curtain with Blinds",
    },
    {
        src: "/Assets/FI_Images/roman_inspiration-1.webp",
        keywords: "Roman Blinds",
    },
    {
        src: "/Assets/FI_Images/roman_inspiration-2-1.webp",
        keywords: "Roman Blinds",
    },
    {
        src: "/Assets/FI_Images/roman_inspiration-3-1.webp",
        keywords: "Roman Blinds",
    },
    {
        src: "/Assets/FI_Images/04-1-1-1-1.webp",
        keywords: "Curtain with Blinds",
    },
    {
        src: "/Assets/FI_Images/colby_inspiration-1-1.webp",
        keywords: "Colby Blinds",
    },
    {
        src: "/Assets/FI_Images/041-1.webp",
        keywords: "Curtain with Blinds",
    },
    {
        src: "/Assets/FI_Images/101-1.webp",
        keywords: "Curtain with Blinds",
    },
    {
        src: "/Assets/FI_Images/colby_inspiration-2-1.webp",
        keywords: "Colby Blinds",
    },
    {
        src: "/Assets/FI_Images/colby_inspiration-3-1.webp",
        keywords: "Colby Blinds",
    },
    {
        src: "/Assets/FI_Images/colby_inspiration-4-1.webp",
        keywords: "Colby Blinds",
    },
    {
        src: "/Assets/FI_Images/luzon_inspiration-1.webp",
        keywords: "Luzon Blinds",
    },
    {
        src: "/Assets/FI_Images/grayson_inspiration-1-1.webp",
        keywords: "Grayson Blinds",
    },
    {
        src: "/Assets/FI_Images/wooden_inspiration-1.webp",
        keywords: "Wooden Venetian Blinds",
    },
    {
        src: "/Assets/FI_Images/panel_inspiration-1-1.webp",
        keywords: "Panel Blinds",
    },
    {
        src: "/Assets/FI_Images/patiricia_inspiration-1-1.webp",
        keywords: "Patricia Blinds",
    },
    {
        src: "/Assets/FI_Images/meliso_inspiration-1-1.webp",
        keywords: "Meliso Blinds",
    },
    {
        src: "/Assets/FI_Images/dorren_inspiration-1-1.webp",
        keywords: "Dorren Blinds",
    },
    {
        src: "/Assets/FI_Images/vertical_inspiration-1-1.webp",
        keywords: "Vertical Blinds",
    },
    {
        src: "/Assets/FI_Images/skylight_inspiration-3-1-1.webp",
        keywords: "Colby Blinds, Skylight Colby Blinds",
    },
];

export default FI_ImagesData;

